export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0012s_0000_Black-&-White-34.0f08baaa.png";